module.exports = __webpack_public_path__ + "images/77a5520ea290321362ae555bdf074903.svg";